<template>
    <section>
        <!-- Scheduler Rows -->
        <div v-for="(row, i) in schedule" :key="i">
            <div class="mb-3 d-flex">
                <!-- <el-row class="mb-3"> -->
                <!-- <el-col :span="24"> -->
                <el-select v-model="row.dayRange" clearable placeholder="When" popper-class="LeadsAutoAssignerPopper"
                           class="mr-3">
                    <el-option v-for="(range, i) in dayRanges" :key="i" :label="range" :value="range"></el-option>
                </el-select>

                <!-- Start Time  -->
                <el-select v-model="row.start" clearable placeholder="Start Time"
                           popper-class="LeadsAutoAssignerPopper">
                    <el-option
                        v-for="(e, i) in timeRanges"
                        :key="i"
                        :label="e.timeHuman"
                        :value="e.timeHuman"
                        :disabled="isStartTimeInvalid(row, i)"
                    ></el-option>
                    <!-- :disabled="isStartTimeInvalid(schedule.stop, e.timeMoment)" -->
                </el-select>

                <span class="mx-2">To</span>

                <!-- Stop Time  -->
                <el-select v-model="row.stop" clearable placeholder="Stop Time" popper-class="LeadsAutoAssignerPopper">
                    <el-option
                        v-for="(e, i) in timeRanges"
                        :key="i"
                        :label="e.timeHuman"
                        :value="e.timeHuman"
                        :disabled="isStopTimeInvalid(row.start, e.timeMoment)"
                    ></el-option>
                </el-select>

                <el-button type="danger" icon="el-icon-circle-close" class="ml-3"
                           @click="removeSchedule(i)"></el-button>
                <!-- </el-col> -->
                <!-- </el-row> -->
            </div>
        </div>

        <div v-if="schedule && schedule.length === 0" class="text-danger">Scheduler is disabled.</div>

        <el-button
            type="success"
            icon="el-icon-plus"
            class="btn-schedule-add"
            @click="addNewSchedule"
            :disabled="!isNewScheduleAllowed"
        >
            Add
        </el-button>
    </section>
</template>

<script>
import moment from "moment"

export default {
    name: "SchedulePicker",
    components: {},
    props: {
        timePickerFormat: {type: String, default: "hh:mm A"},
        hoursIncrement: {type: Number, default: 0.5},
        dayRanges: {
            type: Array,
            default: () => ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
        },
        value: {type: Array, default: () => []}
    },
    data() {
        return {
            // schedule: [],
            newScheduleRow: {dayRange: null, start: null, stop: null}
        }
    },
    computed: {
        isNewScheduleAllowed() {
            if (!Array.isArray(this.schedule)) return false

            // Rules
            const isEmpty = this.schedule.length === 0
            const hasNullValues = this.schedule.map(e => Object.values(e).includes(null)).includes(true)

            // Allow if schedule is empty
            if (isEmpty) return true

            // Deny if schedule contains null values
            if (hasNullValues) return false

            // Allow by default
            return true
        },

        timeRanges() {
            const ranges = []
            const start = moment().startOf("day")
            const hoursIncrement = this.hoursIncrement
            for (let i = 0; i < 24 / hoursIncrement + 1; i++) {
                const time = moment(start.add(i == 0 ? 0 : hoursIncrement, "hours"))
                ranges.push({timeMoment: time, timeHuman: time.format(this.timePickerFormat)})
            }
            return ranges
        },

        schedule: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit("change", val)
            }
        }
    },
    watch: {},
    mounted() {
    },
    updated() {
    },
    activated() {
    },
    methods: {
        isStartTimeInvalid(schedule) {
        },

        isStopTimeInvalid(startTimeString, momentTime) {
        },

        addNewSchedule() {
            console.log("addNewSchedule()")
            // this.$store.commit("addNewScheduleRow")
            const row = Object.assign({}, this.newScheduleRow)
            this.schedule.push(row)
        },

        removeSchedule(index) {
            this.$delete(this.schedule, index)
        }
    }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';
</style>

<style lang="scss">
.LeadsAutoAssignerPopper {
    z-index: 9999 !important;
}
</style>
